import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { PlatformService } from '@/utils/platform';
import { redirectPersistenceService } from '@/services/redirectPersistence';
import { LegalAcceptanceGate } from '@/components/LegalAcceptanceModal';

const ProtectedRoute: React.FC = () => {
  const { user, isLoading, legalAcceptancePending, legalPendingDocuments, clearLegalAcceptance } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    // Store the current path for redirect after login (deep linking support),
    // tagged with whoever last signed in on this browser
    const currentPath = location.pathname + location.search;
    redirectPersistenceService.setRedirectUrl(currentPath, redirectPersistenceService.getLastSignedInUserId());

    // Platform-aware redirect
    const loginPath = PlatformService.isNative() ? '/mobile-login' : '/login';
    return <Navigate to={loginPath} replace />;
  }

  // Legal acceptance gate — blocks dashboard rendering until all documents accepted
  if (legalAcceptancePending && legalPendingDocuments.length > 0) {
    return (
      <LegalAcceptanceGate
        pendingDocuments={legalPendingDocuments}
        onAccepted={clearLegalAcceptance}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
